import { defineComponent as n, openBlock as o, createBlock as t, unref as l, mergeProps as p, withCtx as i, createElementVNode as h } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const V = /* @__PURE__ */ n({
  name: "IconZipperInSquareFilled",
  __name: "IconZipperInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const r = a;
    return (d, e) => (o(), t(l(m), p(r, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        h("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12M11.654 14.5a.5.5 0 0 0-.489.396l-.535 2.5A.5.5 0 0 0 11.118 18h1.764a.5.5 0 0 0 .488-.605l-.535-2.5a.5.5 0 0 0-.49-.395h-.69M10 12a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h1.5A.5.5 0 0 0 12 13v-1h-2m2-1.5V12h2a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5h-2M10 9a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5h2V9h-2m2-1.5V9h2a.5.5 0 0 0 .5-.5V8A.5.5 0 0 0 14 7.5h-2M10 6a.5.5 0 0 0-.5.5V7A.5.5 0 0 0 10 7.5h2v-1A.5.5 0 0 0 11.5 6H10",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  V as default
};
